import PageHeader from "../components/PageHeader";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQS = [
  { q: "How does CashPark price its exchange rate?", a: "We start from the mid-market NGN↔CAD rate (sourced from public FX feeds) and apply a transparent margin. That margin is shown to you in every quote — no hidden FX add-ons." },
  { q: "How long do transfers take?", a: "Most CAD → NGN transfers settle in your recipient's Nigerian bank within hours after we confirm payment and KYC. Timing can vary based on banking hours and compliance checks." },
  { q: "What documents do I need to sign up?", a: "A government-issued ID, proof of address, and (for larger amounts) source-of-funds documentation. The entire verification is digital and usually takes under 10 minutes." },
  { q: "Is CashPark licensed?", a: "Yes. We operate as a registered money services business and follow FINTRAC (Canada) reporting standards, with CBN-compliant payout partners in Nigeria." },
  { q: "What are the minimum and maximum transfer amounts?", a: "Minimum is the equivalent of CAD 3. Maximum per transfer depends on your verification tier — contact us for higher-limit options." },
  { q: "How do I track my transfer?", a: "Once you initiate a transfer, you receive email updates at every step: received, processing, paid out. You can also see live status in your dashboard." },
  { q: "What if my recipient doesn't receive the money?", a: "Email us at contact@mycashpark.com or call our line. We trace and resolve transfer issues within 1 business day, and refund in full where a payout failed." },
  { q: "Are there refunds if I cancel?", a: "If a transfer hasn't been paid out yet, you can cancel for a full refund. Once it has been delivered to the recipient's account, it cannot be reversed — please double-check details before confirming." },
];

export default function FAQ() {
  return (
    <div data-testid="faq-page">
      <PageHeader
        eyebrow="FAQ"
        title="Answers to the questions we hear most."
        subtitle="Can't find what you need? Drop us a line on the Contact page — we reply within one business day."
      />
      <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="text-left font-display text-lg text-[#0B192C] hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-slate-600 leading-relaxed text-base">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </section>
    </div>
  );
}
